import React from 'react'
import { Link } from 'react-router-dom'
import GallerySection from '../components/GallerySection'
import { imageUrl } from '../lib/images'

export default function MadUdAfHusetPage() {
  const buffets = [
    {
      nr: '52',
      title: '1 slags kød stegebuffet',
      desc: 'Stegebuffet klar til servering ekskl. udskæring. Vælg frit 1 slags kød fra vores kødudvalg.',
      price: '85 kr.',
      min: 'Min. 25 personer',
    },
    {
      nr: '50',
      title: '2 slags kød stegebuffet',
      desc: 'Stegebuffet klar til servering ekskl. udskæring. Vælg frit 2 slags kød fra vores kødudvalg.',
      price: '95 kr.',
      min: 'Min. 25 personer',
      popular: true,
    },
    {
      nr: '51',
      title: '3 slags kød stegebuffet',
      desc: 'Stegebuffet klar til servering ekskl. udskæring. Vælg frit 3 slags kød fra vores kødudvalg.',
      price: '105 kr.',
      min: 'Min. 25 personer',
    },
  ]

  return (
    <div className="py-10 sm:py-16 space-y-16">
      {/* Intro Header */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#241F1C] tracking-tight leading-tight">
              Mad ud af huset med råvarer i høj kvalitet
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-[#6E635C] leading-relaxed">
              Hos Overgaard Pattegrise står vi klar til at levere lækker selskabsmad til din næste fest.
              Vores populære stegebuffeter leveres klar til servering og kan kombineres med 1, 2 eller 3
              forskellige typer kød samt vores komplette tilbehørspakke.
            </p>

            <div className="pt-2 flex flex-wrap gap-3 sm:gap-4">
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
                <span>Sammensæt stegebuffet i guiden</span>
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 bg-transparent text-[#241F1C] border border-[#241F1C]/40 px-5 py-2.5 sm:px-6 sm:py-3.5 font-bold text-xs sm:text-sm transition-colors hover:bg-[#241F1C] hover:text-white"
              >
                <span>Kontakt os</span>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden aspect-[4/3]">
              <img
                src={imageUrl('/_assets/img-4784.jpeg', 'width=800,quality=80,format=auto')}
                alt="Buffet og gæster til mad ud af huset arrangement"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* BUFFET OPTIONS CARDS */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
              Vælg antal kødtyper til din buffet
            </h2>
            <p className="mt-2 text-xs sm:text-sm text-[#6E635C]">
              Vælg frit mellem porchetta, marineret svinefilet, svinekam, vikingekøller, glaseret skinke, kylling og oksefilet.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {buffets.map((b) => (
              <div
                key={b.nr}
                className="bg-white p-8 flex flex-col justify-between relative shadow-md transition-shadow duration-300 hover:shadow-xl"
              >
                <div>
                  <h3 className="text-xl font-bold text-[#241F1C] mt-1">{b.title}</h3>
                  <div className="mt-4 mb-4">
                    <span className="text-3xl font-extrabold text-[#241F1C]">{b.price}</span>
                    <span className="text-xs text-[#6E635C] ml-1">/ kuvert</span>
                    <div className="text-xs text-[#6E635C] mt-1 font-semibold">{b.min}</div>
                  </div>
                  <p className="text-xs sm:text-sm text-[#6E635C] leading-relaxed pt-3 border-t border-[#E6DFD5]">
                    {b.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-[#E6DFD5]">
                  <Link
                    to="/bestil"
                    className="w-full text-center block bg-[#241F1C] hover:bg-[#38322E] text-white py-2.5 font-bold text-xs transition-shadow duration-300 hover:shadow-lg"
                  >
                    Vælg i bestillingsguide
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* Tilbehørspakke highlight */}
          <div className="mt-10 bg-white p-8 shadow-md max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6 transition-shadow duration-300 hover:shadow-xl">
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-[#241F1C]">Tilbehørspakken</h3>
              <p className="text-sm text-[#6E635C] max-w-lg leading-relaxed">
                2 valgfrie friske salater m. dressing, 2 slags kartofler (f.eks. flødekartofler) samt friskbagt brød med smør.
              </p>
            </div>
            <div className="text-right shrink-0">
              <div className="text-3xl font-black text-[#241F1C]">
                84 kr. <span className="text-xs font-normal text-[#6E635C]">/ kuvert</span>
              </div>
              <div className="text-xs text-[#6E635C] font-semibold mb-3">Min. 25 personer</div>
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 font-bold text-xs transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <span>Vælg tilbehør</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Galleri */}
      <GallerySection
        gallerySlug="catering-buffet-galleri"
        title="Galleribilleder fra vores stegebuffeter"
        subtitle="Se lækre anretninger af kød, salater og tilbehør."
      />
    </div>
  )
}
